import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import CustomerServiceNotePrompt from 'emun.customer/customer-service-note-prompt'


function CustomerServiceNotePromptDirective($window, $parse, $session) {
    // Introduce custom elements for IE8
    $window.document.createElement('customer-service-note-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onNoteCreated = attr.onNoteCreated || attr.onNoteSaved;

            var $targets = (attr.customerServiceNotePromptClickSelector ? element.find(attr.customerServiceNotePromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.customerServiceNotePrompt || attr.ngModel || attr.customer || attr.note) || {
                    customer: attr.customer,
                    note: attr.note,
                    prospectmode: attr.prospectmode
                };
                if (!model.note) {
                    model.note = {
                        note: '',
                        createdBy: $session.userName,
                        createdOn: new Date()
                    }
                }
                if (model.customer) {
                    model.note.retailerId = model.customer.id;
                }
                CustomerServiceNotePrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (attr.onNoteSaved) {
                            $parse(attr.onNoteSaved)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};

export default CustomerServiceNotePromptDirective;